import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
// routes
import { PATH_DASHBOARD } from "../routes/paths";
// components
import LoadingScreen from "../components/loading-screen";
//
import { useAuthContext } from "./useAuthContext";

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuthContext();
  const { pathname } = useLocation();

  if (!isInitialized) {
    return <LoadingScreen width="100px" height="100px" />;
  }

  if (isAuthenticated) {
    if (!user) {
      return <LoadingScreen width="100px" height="100px" />;
    }

    const isProfileComplete = user?.isProfileComplete !== false;

    if (!isProfileComplete && pathname === "/auth/sign-up") {
      return <>{children}</>;
    }

    return (
      <Navigate
        to={isProfileComplete ? PATH_DASHBOARD.root : "/auth/sign-up"}
        replace
      />
    );
  }

  if (pathname === "/auth/sign-up") {
    return <Navigate to="/auth/login" replace />;
  }

  return <> {children} </>;
}
